// 引入gateway的域名
export default {
    SENSITIVE_WORD_CODE: 31525,

    LANG: {
        ZH_CN: {
            code: 'zh-cn',
            shortname: '简',
        },
        ZH_TW: {
            code: 'zh-tw',
            shortname: '繁',
        },
        EN_US: {
            code: 'en-us',
            shortname: '英',
        },
    },

    wpaIconRoot: '/sites/srv/wpa/conf/wpa/v2/',
    wpaAvatarRoot: '/sites/srv/wpa/conf/wpa/avatar/',

    uploadAvatarUrl: '/mp/imgCommon/crop',

    createWpaUrl: '/tp/wpa/create',
    updateWpaUrl: '/tp/wpa/update',

    newCreateWpaUrl: '/tp/wpa/newCreate',
    newUpdateWpaUrl: '/tp/wpa/newUpdate',

    createVideoWpaUrl: '/receptionConf/videoWpa/create',
    updateVideoWpaUrl: '/receptionConf/videoWpa/update',

    createWxkfWpaUrl: '/v1/kf/reception/receptionConf/wechatSvr/wxWpaGroup/create',
    updateWxkfWpaUrl: '/v1/kf/reception/receptionConf/wechatSvr/wxWpaGroup/update',

    getCreateWpaUrl(version, wpaType) {
        let url = '';
        switch (wpaType) {
        case 'isVideoStandalone':
            url = this.createVideoWpaUrl;
            break;
        case 'isWxWebWpa':
            url = this.createWxkfWpaUrl;
            break;
        }
        if (url) {
            return url;
        }
        return version === 1 ? this.createWpaUrl : this.newCreateWpaUrl;
    },

    getUpdateWpaUrl(version, wpaType) {
        let url = '';
        switch (wpaType) {
        case 'isVideoStandalone':
            url = this.updateVideoWpaUrl;
            break;
        case 'isWxWebWpa':
            url = this.updateWxkfWpaUrl;
            break;
        }
        if (url) {
            return url;
        }
        return version === 1 ? this.updateWpaUrl : this.newUpdateWpaUrl;
    },
};
